import React from 'react';
import { Trans } from '@lingui/react';

const LoadingPhases = {
    default: <Trans id={'component.contact_form.loading'} />,
    sendingEmail: '',
};

export default LoadingPhases;
